var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10256 4.8718C4.10256 2.18118 6.28374 0 8.97436 0C11.665 0 13.8462 2.18118 13.8462 4.8718V8.20513H15.1282C16.6859 8.20513 17.9487 9.46792 17.9487 11.0256V17.1795C17.9487 18.7372 16.6859 20 15.1282 20H2.82051C1.26279 20 0 18.7372 0 17.1795V11.0256C0 9.46792 1.26279 8.20513 2.82051 8.20513H4.10256V4.8718ZM5.64103 8.20513H12.3077V4.8718C12.3077 3.03085 10.8153 1.53846 8.97436 1.53846C7.13341 1.53846 5.64103 3.03085 5.64103 4.8718V8.20513ZM2.82051 9.74359C2.11246 9.74359 1.53846 10.3176 1.53846 11.0256V17.1795C1.53846 17.8875 2.11246 18.4615 2.82051 18.4615H15.1282C15.8363 18.4615 16.4103 17.8875 16.4103 17.1795V11.0256C16.4103 10.3176 15.8363 9.74359 15.1282 9.74359H2.82051ZM8.97436 12.3077C9.39919 12.3077 9.74359 12.6521 9.74359 13.0769V15.1282C9.74359 15.553 9.39919 15.8974 8.97436 15.8974C8.54952 15.8974 8.20513 15.553 8.20513 15.1282V13.0769C8.20513 12.6521 8.54952 12.3077 8.97436 12.3077Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocked);
export default __webpack_public_path__ + "static/media/icon-locked.7348b98fa198c690284241e44e07452b.svg";
export { ForwardRef as ReactComponent };